export function OutlineGlassIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.56152 3.5625L11.9999 12.0009L20.4383 3.5625"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M20.4383 20.4384L11.9999 12L3.56152 20.4384"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M11.9989 4.00008L3.99902 12L11.9989 19.9999L19.9989 12L11.9989 4.00008Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M19.08 3H4.92C3.85961 3 3 3.85961 3 4.92V19.08C3 20.1404 3.85961 21 4.92 21H19.08C20.1404 21 21 20.1404 21 19.08V4.92C21 3.85961 20.1404 3 19.08 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}
